import React from "react";
import styled from "@emotion/styled";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Legend,
  Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Legend,
  Tooltip,
  ChartDataLabels,
);

const SectionBarChart = ({ sections, cards }) => {
  const barThickness = Math.min(35, 100 / cards.length);

  const data = {
    labels: sections,
    datasets: cards.map((c) => ({
      label: c.name,
      data: sections.map((s) => c.scores?.[s] ?? 0),

      backgroundColor: c.color,
      hoverBackgroundColor: c.color,
      borderColor: c.color,
      borderWidth: 1,
      borderRadius: 4,

      categoryPercentage: 1,
      barPercentage: 1,
      barThickness,
    })),
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top", labels: { boxWidth: 10, font: { size: 12 } } },
      tooltip: {
        callbacks: { label: (ctx) => `${ctx.dataset.label}: ${ctx.parsed.y}%` },
      },
      datalabels: { display: false },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { font: { size: 10 }, color: "#353E4C" },
        title: {
          display: true,
          text: "Sections",
          font: { size: 12, weight: "500" },
          color: "#353E4C",
        },
      },
      y: {
        beginAtZero: true,
        suggestedMax: 100,
        ticks: { stepSize: 20, callback: (v) => `${v}%`, color: "#353E4C" },
        grid: { color: "#F1F2F4" },
        title: {
          display: true,
          text: "Cycles in (%)",
          font: { size: 12, weight: "500" },
          color: "#353E4C",
        },
      },
    },
  };

  return (
    <ChartBox>
      <Bar data={data} options={options} />
    </ChartBox>
  );
};

const ChartBox = styled.div`
  height: 26rem;
  min-width: ${(props) => 0}px;
`;

export default SectionBarChart;
